import React from 'react';
import Toast from './Toast';
import { useToast } from '@/hooks/useToast';

interface ToastProviderProps {
  children: React.ReactNode;
}

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const { message, type, isVisible, hideToast } = useToast();

  return (
    <>
      <Toast
        message={message}
        type={type}
        isVisible={isVisible}
        onClose={hideToast}
      />
      {children}
    </>
  );
};

export default ToastProvider; 